<template>
  <div>
    <van-cell class="ry-form__location" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div v-if="isRead">
          <div class="location-content">
            {{current.valueToString()}}
            <i v-if="current.value" class="iconfont icon-location" style="cursor: pointer" @click="checkLocation"></i>
          </div>
          <div
            v-if="current.showGeographic && current.value.latitude && current.value.longitude"
            style="color: #9e9e9e; font-size: 12px; line-height: 16px">
            维度：{{current.value.latitude}},&nbsp;&nbsp;经度：{{current.value.longitude}}
          </div>
        </div>
        <div v-if="!isRead">
          <div class="location-content">
            {{content}}
            <i v-if="current.value" class="iconfont icon-location" style="cursor: pointer" @click="checkLocation"></i>
          </div>
          <div
            v-if="current.showGeographic && current.value.latitude && current.value.longitude"
            style="color: #9e9e9e; font-size: 12px; line-height: 16px">
            维度：{{current.value.latitude}},&nbsp;&nbsp;经度：{{current.value.longitude}}
          </div>
          <van-button
            block
            type="primary"
            @click="getLocation"
            size="small">
            获取当前位置
          </van-button>
        </div>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__location-compact">


      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div v-if="isRead">
            <div class="location-content">
              {{current.valueToString() || '暂无内容'}}
              <i v-if="current.value" class="iconfont icon-location" style="cursor: pointer" @click="checkLocation"></i>
            </div>
            <div
              v-if="current.showGeographic && current.value.latitude && current.value.longitude"
              style="color: #9e9e9e; font-size: 12px; line-height: 16px">
              维度：{{current.value.latitude}},&nbsp;&nbsp;经度：{{current.value.longitude}}
            </div>
          </div>
          <div v-else>
            <div
              v-if="content"
              class="location-content">
              {{content}}
              <i v-if="current.value" class="iconfont icon-location" style="cursor: pointer" @click="checkLocation"></i>
            </div>
            <div
              v-if="current.showGeographic && current.value.latitude && current.value.longitude"
              style="color: #9e9e9e; font-size: 12px; line-height: 16px; margin-bottom: 5px;">
              纬度：{{current.value.latitude}},&nbsp;&nbsp;经度：{{current.value.longitude}}
            </div>
            <van-button
              block
              type="primary"
              :disabled="isReadOnly"
              @click="getLocation"
              size="small">
              获取当前位置
            </van-button>
          </div>
        </template>
      </van-field>
    </div>

    <LocationPopup
      ref="locationPopup"
      :scopeRadius="current.changeScope"
      @selectComplete="selectLocationComplete"
    ></LocationPopup>
    <ShowLocationPopup
      ref="showLocationDialog"
      v-if="current.value"
      :latitude="current.value.latitude"
      :longitude="current.value.longitude"
    ></ShowLocationPopup>
  </div>

</template>

<script>
  import {current} from './mixin'
  import LocationPopup from "../../component/LocationPopup";
  import ShowLocationPopup from "../../component/ShowLocationPopup";

  export default {
    mixins: [current],
    data() {
      return {
        content: ''
      }
    },
    created() {
      this.content = this.current.valueToString()
    },
    mounted() {
      console.log('location', this.current.root, this.current.autoLocation, this.isFill, this.current.value)
      if ((!this.current.value || !this.current.value.latitude || !this.current.value.longitude) &&
        this.current.autoLocation &&
        this.isFill) {
        this.$wx.ready(() => {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          this.actionFetchLocation()
        });
      }
    },
    methods: {
      actionFetchLocation() {
        this.fetchLocation(err => {
          if (err) {
            setTimeout(() => {
              this.actionFetchLocation()
            }, 1000)
          }
        })
      },
      getLocation() {
        if (this.isReadOnly) {
          return
        }

        if (this.current.allowChange) {
          if (this.$refs.locationPopup) {
            this.$refs.locationPopup.open()
          }
        } else {
          this.fetchLocation()
        }
      },
      fetchLocation(callback) {
        const toast = this.$toast.loading({message: '加载中...'})
        if (window.isWexin || window.isWxWork) {
          this.wxGetLocation(toast, callback)
        } else if (window.isLark) {
          this.larkGetLocation(toast, callback)
        } else if (window.isDingtalk) {
          this.dingChooseLocation(toast, callback)
        }
      },
      wxGetLocation(toast, callback) {
        new Promise((resolve, reject) => {
          this.$wx.getLocation({
            type: 'gcj02',
            success: res => {
              resolve(res)
            },
            fail: err => {
              console.log('get location err1', err)
              reject(err)
            }
          })
        })
          .then(res => {
            console.log('getLocation--', res)
            return this.$store.dispatch('actionMiniAppAddressGet', {
              latitude: res.latitude,
              longitude: res.longitude
            })
          })
          .then(res => {
            Object.assign(this.current.value, res)
            this.content = this.current.valueToString(res)
            this.controlChange()
            toast.clear()
          })
          .catch(err => {
            toast.clear()
            console.log('get location err2', err)
            if (callback) {
              callback(err)
            } else {
              if (err.errMsg === 'getLocation:fail') {
                this.$toast.fail({
                  message: '获取位置信息失败，请开启微信定位权限'
                })
              } else {
                this.$toast.fail({
                  message: err.errMsg
                })
              }
            }
          })
      },
      larkGetLocation(toast, callback) {
        console.log('get-location', window.tt)
        this.$tt.ready(() => {
          console.log('get-location11--', tt)

          new Promise((resolve, reject) => {

            tt.getLocation({
              type: 'gcj02',
              success: res => {
                resolve(res)
                console.log(`getLocation: success ${JSON.stringify(res)}`)
              },
              fail: err => {
                reject(err)
                console.log('getLocation fail', JSON.stringify(err))
              },
            });
          })
            .then(res => {
              console.log('getLocation--', res)
              return this.$store.dispatch('actionMiniAppAddressGet', {
                latitude: res.latitude,
                longitude: res.longitude
              })
            })
            .then(res => {
              Object.assign(this.current.value, res)
              this.content = this.current.valueToString(res)
              this.controlChange()
              toast.clear()
            })
            .catch(err => {
              toast.clear()
              console.log('get location err2', err)
              if (callback) {
                callback(err)
              } else {
                if (err.errMsg === 'getLocation:fail') {
                  this.$toast.fail({
                    message: '获取位置信息失败，请开启飞书定位权限'
                  })
                } else {
                  this.$toast.fail({
                    message: err.errMsg
                  })
                }
              }
            })
        })

      },

      dingChooseLocation(toast, callback) {
        this.$dd.ready(() => {
          console.log('get-location11--', this.$dd)
          new Promise((resolve, reject) => {
            this.$dd.device.geolocation.get({
              targetAccuracy: 20, // 期望定位精度半径(单位米)
              coordinate: 1, // 1：获取高德坐标 0：获取标准坐标
              withReGeocode: true, // 是否需要带有逆地理编码信息。
              useCache: false, //默认是true，如果需要频繁获取地理位置，请设置false
              onSuccess: function (result) {
                resolve(result)
              },
              onFail: function (err) {
                reject(err)
              }
            });
          })
            .then(res => {
              console.log('getLocation--', res)
              return this.$store.dispatch('actionMiniAppAddressGet', {
                latitude: res.latitude,
                longitude: res.longitude
              })
            })
            .then(res => {
              Object.assign(this.current.value, res)
              this.content = this.current.valueToString(res)
              this.controlChange()
              toast.clear()
            })
            .catch(err => {
              toast.clear()
              console.log('get location err2', err)
              if (callback) {
                callback(err)
              } else {
                if (err.errMsg === 'getLocation:fail') {
                  this.$toast.fail({
                    message: '获取位置信息失败，请开启钉钉定位权限'
                  })
                } else {
                  this.$toast.fail({
                    message: err.errMsg
                  })
                }
              }
            })
        })
      },

      selectLocationComplete(val) {
        const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('actionMiniAppAddressGet', {
          latitude: val.latitude,
          longitude: val.longitude
        })
          .then(res => {
            Object.assign(this.current.value, res)
            this.content = this.current.valueToString(res)
            this.controlChange()
            toast.clear()
          })
          .catch(console.error)
      },
      checkLocation() {
        if (this.$refs.showLocationDialog) {
          this.$refs.showLocationDialog.open()
        }
      }
    },
    components: {LocationPopup, ShowLocationPopup},
    watch: {
      'current.value'() {
        console.log('watch', this.current.value)
        this.content = this.current.valueToString()
      }
    }
  }
</script>

